import { render, staticRenderFns } from "./Potilaalle.vue?vue&type=template&id=2f7be8ac&"
import script from "./Potilaalle.vue?vue&type=script&lang=js&"
export * from "./Potilaalle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/wordpress/Kaypa-hoito/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f7be8ac')) {
      api.createRecord('2f7be8ac', component.options)
    } else {
      api.reload('2f7be8ac', component.options)
    }
    module.hot.accept("./Potilaalle.vue?vue&type=template&id=2f7be8ac&", function () {
      api.rerender('2f7be8ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/Potilaalle.vue"
export default component.exports